import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
export function Close() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Dialog.Close render={<button type="button" aria-label="Close card type picker" className={css({
      flexShrink: "[0]",
      width: "[32px]",
      height: "[32px]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: "[0]",
      bg: "[transparent]",
      border: "none",
      rounded: "full",
      cursor: "pointer",
      color: "neutral.darkest",
      _hover: {
        bg: "neutral.lightest"
      }
    })}><CloseIcon fill="currentColor" /></button>} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}